const id = (value) => (typeof value === 'string' ? value : value?._id || value?.id || '');
export const helpScope = (user) =>
  JSON.stringify([
    user?.role || '',
    id(user?.distributor),
    id(user?.distributorClinic),
    id(user?.clinic),
    user?.distributorPreviewExpiresAt || '',
    user?.isActive !== false,
  ]);
export const helpIdentity = (user, version) =>
  `${user?._id || user?.id || ''}:${user?.role || ''}:${version || ''}${user?.distributor || user?.distributorClinic || user?.clinic || user?.isActive === false || user?.role === 'master_distributor' ? `:${helpScope(user)}` : ''}`;
export const storedHelpScope = () => {
  try {
    return helpScope(JSON.parse(localStorage.getItem('user')));
  } catch {
    return helpScope(null);
  }
};
